import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/security/auth.service';
import { UserLoggedResponse } from '../../models/user';
import { Subscription, forkJoin, of, Observable } from 'rxjs';
import { ScrollService } from '../../utils/scroll-service';
import { MatDialog } from '@angular/material/dialog';
import { DetalleDialogComponent } from '../common/dialogs/detalle-dialog/detalle-dialog.component';
import { PoblacionService } from '../../services/poblacion/poblacion.service';
import { NotificacionReferidoService } from '../../services/notificacion-referido/notificacion-referido.service';
import { NotificacionDetalleService } from '../../services/notificacion-detalle/notificacion-detalle.service';
import { NotificacionGestionService } from '../../services/gestion-referidos/gestion-referidos.service';
import { tap, catchError, filter } from 'rxjs/operators';
import { ModalNotificacionComisionesComponent } from '../modal-notificacion-comisiones/modal-notificacion-comisiones.component';
import { ComisionesService } from '../../services/comisiones/comisiones.service';
import getHolidays from 'festivos-colombianos';
import { FestivoCO } from '../../models/dias-festivos/dias-festivos';
import { DialogMomentosWowComponent } from '../common/dialogs/dialog-momentos-wow/dialog-momentos-wow.component';
import { MomentosWowService } from '../../services/momentos-wow/momentos-wow.service';
import { NotificacionesService } from '../../services/notificaciones/notificaciones-cotizacion.service';
import { NotificacionesSeguimientoService } from '../../services/notificaciones-seguimiento.service';
 
const MESES_ABREVIADOS = [
  'ENE',
  'FEB',
  'MAR',
  'ABR',
  'MAY',
  'JUN',
  'JUL',
  'AGO',
  'SEP',
  'OCT',
  'NOV',
  'DIC',
];
 
const MAPA_MESES: Record<string, string> = {
  ENE: 'enero',
  FEB: 'febrero',
  MAR: 'marzo',
  ABR: 'abril',
  MAY: 'mayo',
  JUN: 'junio',
  JUL: 'julio',
  AGO: 'agosto',
  SEP: 'septiembre',
  OCT: 'octubre',
  NOV: 'noviembre',
  DIC: 'diciembre',
};
 
@Component({
  selector: 'app-maincontainer',
  templateUrl: './maincontainer.component.html',
  styleUrls: ['./maincontainer.component.css'],
})
export class MaincontainerComponent {
  //@ViewChild('sidebarMenuComponent') sidebarMenuComponent: SidebarMenuComponent;
  public sectionName: string = 'Section Name';
  sidebarActive = false;
  loggedUser: UserLoggedResponse = new UserLoggedResponse();
  private scrollSubscription: Subscription = new Subscription();
  hideScroll: boolean = false;
  showTooltip = false;
  showBadge = true;
  notificationCount = 0;
  usuariosEliminados: number[] = [];
  logInfo: any;
  cedulaAsesor: string = '';
  rolAsesor: string = '';
  usuariosCumplenDosMeses: any[] = [];
  totalUsuariosCumplen: number = 0;
  fechaNotificacionTooltip: string = '';
  lastNotificacionId: number | null = null;
  horaNotificacionExtra: string | null = null;
  showTooltipWrapper: boolean = false;
  esAsesorExterno: boolean = false;
  showTooltipNotificacion1: boolean = false;
  tipoAsesor: string = '';
  idAsesor: number | string = '';
  fechaGeneracionNotificacion: string = '';
  fechaLimiteRadicacion!: Date;
  quincenaActual!: string;
  mesActual!: string;
  anioActual!: number;
  notificacionUsuariosActiva = false;
  notificacionComisionesActiva = false;
  notificacionComisionesGuardada = false;
  notificacionComisionesCreada = false;
  notificacionComisionesActual: any | null = null;
  evaluacionComisionesEnProceso = false;
  fechaNotificacionBD!: Date;
  usuariosNotificar: any[] = [];
  fechaNotificacionTexto: string = '';
  horaNotificacionTexto: string = '';
  fechaNotificacionService: string = '';
  momentosWowData: any[] = [];
  notificacionMomentosWow = false;
  cargandoMomentosWow = false;
  notificacionesSeguimientoNoLeidas = 0;
  private notificacionesCotizacionSub = new Subscription();
  private contadorCotizacionSub?: Subscription;
 
  constructor(
    public router: Router,
    private authService: AuthService,
    private scrollService: ScrollService,
    private poblacionService: PoblacionService,
    private dialog: MatDialog,
    private notificacionReferidoService: NotificacionReferidoService,
    private notificacionDetalleService: NotificacionDetalleService,
    private comisionesService: ComisionesService,
    private notificacionGestionService: NotificacionGestionService,
    private elementRef: ElementRef,
    private momentosWowService: MomentosWowService,
    private notificacionesService: NotificacionesService,
    private notificacionesSeguimientoService: NotificacionesSeguimientoService,
  ) {
    this.getLoggedData();
  }
 
  closeSession() {
    this.authService.logOut();
  }
 
  @ViewChild('notificationContainer', { static: false })
  notificationContainer!: ElementRef;
 
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (!this.showTooltip) return;
 
    const clickedInside = this.notificationContainer?.nativeElement.contains(
      event.target,
    );
 
    if (!clickedInside) {
      this.showTooltip = false;
    }
  }
 
  async getLoggedData() {
    this.loggedUser = await this.authService.getAuthInfo();
    console.log(this.loggedUser);
    sessionStorage.setItem('user', JSON.stringify(this.loggedUser));
 
    this.logInfo = await this.authService.getAuthInfo();
    console.log('servicio auth documento en maincontainer', this.logInfo);
 
    const userCC = this.logInfo?.document;
    this.cedulaAsesor = userCC.split('.')[1].trim();
    console.log('MainContainer: cedulaAsesor ->', this.cedulaAsesor);
 
    this.rolAsesor = this.logInfo?.roles[0].claveRol || '';
    console.log('MainContainer: rolAsesor ->', this.rolAsesor);
 
    this.tipoAsesor = this.logInfo?.roles[0].nombreRol || '';
    console.log('MainContainer: tipoAsesor ->', this.tipoAsesor);
 
    this.cargarNotificacionesIniciales();
 
    this.obtenerCodigoAsesor();
 
    this.notificacionMomentosWow = false;
    this.actualizarContadorNotificaciones();
 
    this.cargarNotificacionMomentosWow();
 
  }
 
  parseFechaColombia(fechaISO: string): Date {
    const [fecha, hora] = fechaISO.split('T');
    const [y, m, d] = fecha.split('-').map(Number);
    const [hh, mm, ss] = hora.split(':').map(Number);
 
    return new Date(y, m - 1, d, hh, mm, ss);
  }
 
  obtenerCodigoAsesor(): void {
    this.comisionesService.consultarCodigoAsesor(this.cedulaAsesor).subscribe({
      next: (resp) => {
        console.log('Asesor:', resp);
        this.idAsesor = resp.idasesor;
 
        this.evaluarNotificacionComisiones();
        this.cargarContadorNotificacionesCotizacion();
      },
      error: () => {
        console.error('No fue posible obtener el tipo de asesor');
      },
    });
  }
 
  actualizarContadorNotificaciones(): void {
    // Contador de usuarios activos que cumplen dos meses
    const usuariosActivos = this.usuariosCumplenDosMeses.length > 0 ? 1 : 0;
    // Contador con base en si la notificación de comisiones está activa
    const comisiones = this.notificacionComisionesActiva ? 1 : 0;
 
    const MomentosWow = this.notificacionMomentosWow ? 1 : 0;
    const cotizaciones = this.notificacionesSeguimientoNoLeidas > 0 ? 1 : 0;
 
    this.notificationCount = usuariosActivos + comisiones + MomentosWow + cotizaciones;
    this.showBadge = this.notificationCount > 0;
  }
 
  generarHoraNotificacionExtra(fechaBase?: Date) {
    if (!fechaBase) return;
    if (this.horaNotificacionExtra) return;
 
    let horas = fechaBase.getHours();
    const minutos = fechaBase.getMinutes().toString().padStart(2, '0');
    const ampm = horas >= 12 ? 'PM' : 'AM';
    horas = horas % 12 || 12;
 
    this.horaNotificacionExtra = `${horas}:${minutos} ${ampm}`;
  }
 
  calcularFechaDosMeses(fechaInicio: string): Date {
    const [year, month, day] = fechaInicio.split('-').map(Number);
 
    // Fecha LOCAL, sin UTC
    const fecha = new Date(year, month - 1, day);
    fecha.setMonth(fecha.getMonth() + 2);
 
    return fecha;
  }
 
  invertirNombreCompleto(nombre: string): string {
    if (!nombre) return '';
 
    const partes = nombre.trim().split(/\s+/);
 
    if (partes.length <= 2) {
      return nombre;
    }
 
    const nombres = partes.slice(2).join(' ');
    const apellidos = partes.slice(0, 2).join(' ');
 
    return `${nombres} ${apellidos}`;
  }
 
  formatearFecha(fecha: string | Date): string {
    const d = new Date(fecha);
 
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const anio = d.getFullYear();
 
    return `${dia}/${mes}/${anio}`;
  }
 
  cargarNotificacionesIniciales() {
    const request = {
      identificationAsesor: this.cedulaAsesor,
      typeAsesor: this.rolAsesor,
      genero: '',
      parentesco: '',
      programa: '',
      edad: '',
    };
 
    this.poblacionService.consultPoblacionActivos(request).subscribe({
      next: (response) => {
        const hoy = new Date();
 
        // Filtrar mayores de 18 y contratantes válidos
        const usuariosContratantes = response.data.filter((u: any) => {
          if (!u.identificacion || !u.NumContratante) return false;
          if (
            String(u.identificacion).trim() !== String(u.NumContratante).trim()
          )
            return false;
 
          const fechaNacimiento = new Date(u.Fecha_Naci_Usua);
          const edad =
            hoy.getFullYear() -
            fechaNacimiento.getFullYear() -
            (hoy <
              new Date(
                hoy.getFullYear(),
                fechaNacimiento.getMonth(),
                fechaNacimiento.getDate(),
              )
              ? 1
              : 0);
 
          return edad >= 18;
        });
 
        // Agrupar por contratante
        const agrupadosPorContratante: { [key: string]: any[] } = {};
        usuariosContratantes.forEach((u: any) => {
          if (!agrupadosPorContratante[u.NumContratante])
            agrupadosPorContratante[u.NumContratante] = [];
          agrupadosPorContratante[u.NumContratante].push(u);
        });
 
        const cumpleDosMeses = (fechaInicio: string) => {
          const fi = new Date(fechaInicio);
          const desde = new Date(fi);
          desde.setMonth(desde.getMonth() + 2);
          const hasta = new Date(fi);
          hasta.setMonth(hasta.getMonth() + 4);
          return hoy >= desde && hoy < hasta;
        };
 
        this.usuariosNotificar = [];
 
        Object.values(agrupadosPorContratante).forEach(
          (afiliaciones: any[]) => {
            afiliaciones.sort(
              (a, b) =>
                new Date(a.FechaIniServ).getTime() -
                new Date(b.FechaIniServ).getTime(),
            );
 
            const mi = afiliaciones.filter((a) => a.Linea === 'MI');
            if (mi.length > 0) {
              const ultimaMI = mi.reduce((prev, curr) =>
                new Date(prev.FechaIniServ) > new Date(curr.FechaIniServ)
                  ? prev
                  : curr,
              );
              if (cumpleDosMeses(ultimaMI.FechaIniServ))
                this.usuariosNotificar.push(ultimaMI);
              return;
            }
 
            if (cumpleDosMeses(afiliaciones[0].FechaIniServ))
              this.usuariosNotificar.push(afiliaciones[0]);
          },
        );
 
        this.notificacionGestionService
          .obtenerPorAsesor(this.cedulaAsesor)
          .subscribe((gestiones) => {
            const detallesGestionados = new Set(
              gestiones.map((g) => g.idDetalle),
            );
 
            // Solo usuarios que NO tienen detalle gestionado
            this.usuariosNotificar = this.usuariosNotificar.filter((u) => {
              const idUsuario = Number(
                String(u.identificacion).replace(/[^0-9]/g, ''),
              );
              return !gestiones.some(
                (g) =>
                  g.idUsuario === idUsuario &&
                  detallesGestionados.has(g.idDetalle),
              );
            });
 
            const usuariosIds = this.usuariosNotificar.map((u) =>
              Number(String(u.identificacion).replace(/[^0-9]/g, '')),
            );
 
            if (usuariosIds.length > 0) {
              this.notificacionReferidoService
                .crearNotificacionSiAplica(
                  Number(this.cedulaAsesor),
                  usuariosIds,
                )
                .subscribe({
                  next: () => this.cargarDetallesActivos(),
                  error: (err) =>
                    console.error('Error creando notificaciones', err),
                });
            } else {
              this.cargarDetallesActivos();
            }
          });
      },
      error: (err) =>
        console.error('Error al cargar notificaciones iniciales', err),
    });
  }
 
  obtenerPeriodoAEvaluar(hoy: Date): {
    anio: number;
    mesIndex: number;
    quincena: '1Q' | '2Q';
  } {
    const dia = hoy.getDate();
    let anio = hoy.getFullYear();
    let mesIndex = hoy.getMonth(); // 0-11
    let quincena: '1Q' | '2Q';
 
    if (dia >= 14) {
      // 👉 Del 15 al fin de mes → 1Q del mes actual
      quincena = '1Q';
    } else {
      // 👉 Del 1 al 14 → 2Q del mes anterior
      quincena = '2Q';
      mesIndex--;
 
      if (mesIndex < 0) {
        mesIndex = 11;
        anio--;
      }
    }
 
    return { anio, mesIndex, quincena };
  }
 
  evaluarNotificacionComisiones(): void {
 
    if (!this.idAsesor || this.evaluacionComisionesEnProceso) return;
 
    this.evaluacionComisionesEnProceso = true;
 
    // Solo externos
    if (this.tipoAsesor !== 'Asesor Externo') {
      this.resetComisiones();
      return;
    }
 
    const hoy = new Date();
    const { anio, quincena, mesIndex } = this.obtenerPeriodoAEvaluar(hoy);
    const periodo = `${quincena}${MESES_ABREVIADOS[mesIndex]}`;
 
    this.anioActual = anio;
    this.quincenaActual = quincena === '1Q' ? 'Primera' : 'Segunda';
    this.mesActual = MAPA_MESES[MESES_ABREVIADOS[mesIndex]];
 
    const dto_1 = {
      nombreClave: 'getextComprobante',
      jsonParametros: JSON.stringify({
        documento: this.idAsesor.toString(),
        anio: this.anioActual.toString(),
        periodo,
      }),
    };
 
    const dto_2 = {
      nombreClave: 'getextDetalle',
      jsonParametros: JSON.stringify({
        documento: this.idAsesor.toString(),
        anio: this.anioActual.toString(),
        periodo,
      }),
    };
 
    forkJoin({
      comprobantes: this.comisionesService
        .consultarComprobantes(dto_1)
        .pipe(catchError(() => of(null))),
 
      detallado: this.comisionesService
        .consultarDetallado(dto_2)
        .pipe(catchError(() => of(null))),
    }).subscribe({
      next: ({ comprobantes, detallado }) => {
        const hayComprobantes =
          comprobantes?.status === true &&
          Array.isArray(comprobantes?.data) &&
          comprobantes.data.length > 0;
 
        const hayDetalle = detallado?.status === true;
        const hayData = hayComprobantes || hayDetalle;
 
        let fechaCargueReal: Date | null = null;
 
        if (hayComprobantes) {
          const stringFecha = comprobantes.data[0].FECHA_CARGUE;
          this.fechaNotificacionService = stringFecha;
 
          if (stringFecha) {
            fechaCargueReal = this.parseFechaYYYYMMDD(stringFecha);
          }
        }
 
        if (!hayData) {
          this.resetComisiones();
          return;
        }
 
        if (!fechaCargueReal) {
          this.resetComisiones();
          return;
        }
 
        this.validarNotificacionBD(fechaCargueReal, hayData);
      },
      error: () => this.resetComisiones(),
    });
  }
 
  validarNotificacionBD(fechaReferencia: Date, hayData: boolean): void {
    this.notificacionReferidoService
      .obtenerPorAsesor(this.cedulaAsesor)
      .subscribe({
        next: (notifs) => {
          const lista = Array.isArray(notifs) ? notifs : [];
 
          // Tomar la última notificación de Comisiones
          const notifComisiones = lista
            .filter((n) => n.modulo === 'Comisiones')
            .sort(
              (a, b) =>
                new Date(b.fechaNotificacion).getTime() -
                new Date(a.fechaNotificacion).getTime(),
            )[0];
 
          if (!notifComisiones) {
            if (hayData) {
              this.crearNotificacionComisiones(fechaReferencia); // ✅ solo si hay data
            } else {
              this.resetComisiones();
            }
            return;
          }
 
          if (!notifComisiones.estado) {
            // Notificación ya expirada o desactivada
            this.ocultarNotificacion();
            return;
          }
 
          // 🔑 Usar directamente la información del backend
          this.fechaNotificacionBD = this.parseFechaColombia(
            notifComisiones.fechaNotificacion,
          );
          this.lastNotificacionId = notifComisiones.idNotificacion;
          this.anioActual = notifComisiones.anio;
          this.mesActual =
            MAPA_MESES[MESES_ABREVIADOS[notifComisiones.mes - 1]];
          this.quincenaActual =
            notifComisiones.quincena === '1Q' ? 'Primera' : 'Segunda';
 
          const fechaLimite = this.calcularFechaLimiteHabiles(
            this.fechaNotificacionBD,
            3,
          );
 
          if (new Date() > fechaLimite) {
            this.notificacionComisionesActiva = false;
            this.ocultarYExpirarNotificacion(notifComisiones.idNotificacion);
            return;
          }
 
          // Mostrar notificación activa
          this.mostrarNotificacion(notifComisiones);
        },
        error: () => this.resetComisiones(),
      });
  }
 
  mostrarNotificacion(notif: any): void {
    this.fechaNotificacionBD = this.parseFechaColombia(notif.fechaNotificacion);
    this.lastNotificacionId = notif.idNotificacion;
 
    this.notificacionComisionesActiva = true;
    this.actualizarContadorNotificaciones();
    this.showTooltipNotificacion1 = true;
    this.showTooltipWrapper = true;
    this.notificacionComisionesCreada = true;
    this.notificacionComisionesGuardada = true;
 
    this.fechaNotificacionTexto = this.fechaNotificacionBD.toLocaleDateString('es-CO', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
 
    //this.horaNotificacionTexto = this.fechaNotificacionBD.toLocaleTimeString(
    //'es-CO',
    //{
    //hour: 'numeric',
    //minute: '2-digit',
    //hour12: true,
    //},
    //);
 
    this.actualizarContadorNotificaciones();
 
    const fechaLimite = this.calcularFechaLimiteHabiles(
      this.fechaNotificacionBD,
      3,
    );
    const tiempoRestante = fechaLimite.getTime() - Date.now();
 
    setTimeout(
      () => {
        this.ocultarYExpirarNotificacion(notif.idNotificacion);
      },
      Math.max(tiempoRestante, 0),
    );
  }
 
  resetComisiones() {
    this.showTooltipNotificacion1 = false;
    this.showTooltipWrapper = false;
    this.notificacionComisionesActiva = false;
    this.notificacionComisionesGuardada = false;
    this.notificacionComisionesCreada = false;
    this.actualizarContadorNotificaciones();
    this.evaluacionComisionesEnProceso = false;
  }
 
  crearNotificacionComisiones(fechaCargue: Date): void {
    if (!this.idAsesor) return;
 
    const hoy = new Date();
    const { anio, mesIndex, quincena } = this.obtenerPeriodoAEvaluar(hoy);
 
    const periodo = `${quincena}${MESES_ABREVIADOS[mesIndex]}`;
 
    this.notificacionReferidoService
      .crearNoticacionComisionesSiAplica(Number(this.cedulaAsesor), fechaCargue)
      .subscribe({
        next: (notif: any) => {
          if (!notif || notif.estado === false || notif.estado === 0 || notif.estado === 'false') {
            this.ocultarNotificacion();
            return;
          }
          // Si el backend devuelve la notificación recién creada, actualizar flags
          this.notificacionComisionesActiva = true;
          this.showTooltipNotificacion1 = true;
          this.showTooltipWrapper = true;
          this.notificacionComisionesCreada = true;
          this.notificacionComisionesGuardada = true;
 
          this.anioActual = anio;
          this.mesActual = MAPA_MESES[MESES_ABREVIADOS[mesIndex]];
          this.quincenaActual = quincena === '1Q' ? 'Primera' : 'Segunda';
 
          // Guardar fecha y hora
          if (notif?.fechaNotificacion) {
            this.fechaNotificacionBD = this.parseFechaColombia(notif.fechaNotificacion);
          } else {
            this.fechaNotificacionBD = fechaCargue;
          }
 
          this.fechaNotificacionTexto =
            this.fechaNotificacionBD.toLocaleDateString('es-CO', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            });
 
          this.horaNotificacionTexto =
            this.fechaNotificacionBD.toLocaleTimeString('es-CO', {
              hour: 'numeric',
              minute: '2-digit',
              hour12: true,
            });
 
          this.lastNotificacionId = notif?.idNotificacion;
 
          this.actualizarContadorNotificaciones();
        },
        error: (err) => console.error(err),
      });
  }
 
  ocultarNotificacion(): void {
    this.showTooltipNotificacion1 = false;
    this.showTooltipWrapper = false;
    this.notificacionComisionesActiva = false;
    this.notificacionComisionesGuardada = false;
    this.notificacionComisionesCreada = false;
    this.actualizarContadorNotificaciones();
  }
 
  ocultarYExpirarNotificacion(idNotificacion: number): void {
    this.showTooltipNotificacion1 = false;
    this.showTooltipWrapper = false;
    this.notificacionComisionesActiva = false;
    this.notificacionComisionesGuardada = false;
    this.notificacionComisionesCreada = false;
    this.actualizarContadorNotificaciones();
 
    this.notificacionReferidoService
      .actualizarEstado(idNotificacion, false)
      .subscribe(() =>
        console.log('Notificación de comisiones expirada automáticamente'),
      );
  }
 
  // Método separado para cargar los detalles activos y mapearlos
  cargarDetallesActivos() {
    this.notificacionDetalleService
      .obtenerDetallesPorAsesor(Number(this.cedulaAsesor))
      .subscribe((detalles) => {
        this.notificacionGestionService
          .obtenerPorAsesor(this.cedulaAsesor)
          .subscribe((gestiones) => {
            const detallesGestionados = new Set<number>(
              gestiones.map((g) => g.idDetalle),
            );
 
            const detallesActivos = detalles.filter(
              (d) => d.estado === true && !detallesGestionados.has(d.idDetalle),
            );
 
            this.usuariosCumplenDosMeses = detallesActivos
              .map((detalle) => {
                const usuario = this.usuariosNotificar.find(
                  (u) =>
                    Number(String(u.identificacion).replace(/[^0-9]/g, '')) ===
                    detalle.idUsuario,
                );
                if (!usuario) return null;
 
                const fechaDosMeses = this.calcularFechaDosMeses(
                  usuario.FechaIniServ,
                );
 
                return {
                  nombre: this.invertirNombreCompleto(usuario.nombre),
                  programa: usuario.Programa,
                  telefono: usuario.Telefono,
                  fechaNotificacion: fechaDosMeses,
                  fechaFormateada: this.formatearFecha(fechaDosMeses),
                  idNormalizado: detalle.idUsuario,
                  idDetalle: detalle.idDetalle,
                  idNotificacion: detalle.idNotificacion,
                  visible: true,
                };
              })
              .filter(Boolean)
              // 🔹 Orden descendente por fecha de notificación
              .sort(
                (a: any, b: any) =>
                  b.fechaNotificacion.getTime() - a.fechaNotificacion.getTime(),
              );
 
            // Actualizar badge
            this.totalUsuariosCumplen = this.usuariosCumplenDosMeses.length;
            this.actualizarContadorNotificaciones();
 
            if (this.usuariosCumplenDosMeses.length > 0) {
              this.fechaNotificacionTooltip =
                this.usuariosCumplenDosMeses[0].fechaFormateada;
            }
          });
      });
  }
 
  toggleTooltip() {
    const esExterno = this.tipoAsesor === 'Asesor Externo';
 
    if (esExterno && this.showTooltipNotificacion1) {
      this.generarHoraNotificacionExtra(this.fechaNotificacionBD);
    }
 
    this.showTooltip = !this.showTooltip;
 
    if (this.showTooltip) {
      this.cargarContadorNotificacionesCotizacion();
      // Ocultar el badge mientras se muestra el tooltip
      this.showBadge = false;
 
      // Filtrar usuarios eliminados para que no se vuelvan a mostrar en la lista
      this.usuariosCumplenDosMeses = this.usuariosCumplenDosMeses.filter(
        (u) => !this.usuariosEliminados.includes(u.idNormalizado),
      );
 
      // Actualizar contadores de la campana
      this.totalUsuariosCumplen = this.usuariosCumplenDosMeses.length;
      this.notificacionUsuariosActiva = this.totalUsuariosCumplen > 0;
 
      this.actualizarContadorNotificaciones();
    }
  }
 
  deleteSpaceAsesor(identification: string): string {
    const parts = identification.split('.');
    return parts.length > 1 ? parts[1].trim() : '';
  }
 
  onNotificationClick(): void {
    if (this.usuariosCumplenDosMeses.length === 0) return;
 
    const dialogRef = this.dialog.open(DetalleDialogComponent, {
      width: '700px',
      maxHeight: '90vh',
      data: { users: this.usuariosCumplenDosMeses },
    });
 
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;
 
      if (res.usuariosEliminados?.length) {
        res.usuariosEliminados.forEach((idUsuario: number) => {
          this.usuariosCumplenDosMeses = this.usuariosCumplenDosMeses.filter(
            (u) => u.idNormalizado !== idUsuario,
          );
        });
      }
 
      this.totalUsuariosCumplen = this.usuariosCumplenDosMeses.length;
      this.actualizarContadorNotificaciones();
 
      // Siempre el primero del array
      if (this.usuariosCumplenDosMeses.length > 0) {
        this.fechaNotificacionTooltip =
          this.usuariosCumplenDosMeses[0].fechaFormateada;
      } else {
        this.fechaNotificacionTooltip = '';
      }
    });
  }
 
  onExtraNotificationClick(): void {
    if (!this.fechaNotificacionBD) return;
 
    const fechaGeneracion = new Date(this.fechaNotificacionBD);
    const fechaLimite = this.calcularFechaLimiteHabiles(fechaGeneracion, 3);
 
    let tiempoRestante = fechaLimite.getTime() - Date.now();
    if (tiempoRestante < 0) tiempoRestante = 0;
 
    // Usar directamente la quincena y mes que ya calculamos
    this.dialog.open(ModalNotificacionComisionesComponent, {
      panelClass: 'modal-notificacion-comisiones',
      data: {
        fechaLimite,
        quincena: this.quincenaActual,
        mes: this.mesActual, // ya viene calculado según nuestra lógica 15-31 / 1-14
        anio: this.anioActual,
      },
    });
  }
 
  crearNotificacionMomentosWowBD() {
    this.notificacionReferidoService
      .crearNotificacionMomentosWow(Number(this.cedulaAsesor))
      .subscribe({
        next: () => {
          this.notificacionMomentosWow = true;
          this.actualizarContadorNotificaciones();
        },
        error: (err) => console.error(err),
      });
  }
 
  CrearNotificacionMomentosWow() {
    this.cargarNotificacionMomentosWow();
  }
 
  cargarNotificacionMomentosWow() {
    forkJoin({
      visibles: this.momentosWowService.listarVisibles(this.cedulaAsesor),
      notifs: this.notificacionReferidoService.obtenerPorAsesor(this.cedulaAsesor),
    }).subscribe({
      next: ({ visibles, notifs }: { visibles: any[]; notifs: any[] }) => {
        const listaVisibles = (Array.isArray(visibles) ? visibles : []).filter(
          (v) =>
            String(v.visible) === '1' &&
            String(v.gestionado) === '0' &&
            String(v.idAsesor) === String(this.cedulaAsesor),
        );
 
        const listaNotifs = Array.isArray(notifs) ? notifs : [];
 
        const notifWow = listaNotifs
          .filter((n) => n.modulo === 'Momentos_Wow')
          .sort(
            (a, b) =>
              new Date(b.fechaNotificacion).getTime() -
              new Date(a.fechaNotificacion).getTime(),
          )[0];
 
        const wowActiva =
          !!notifWow && (notifWow.visible === 1 || notifWow.visible === true);
 
        if (listaVisibles.length === 0) {
          this.notificacionMomentosWow = false;
          this.actualizarContadorNotificaciones();
 
          if (wowActiva && notifWow?.idNotificacion) {
            this.notificacionReferidoService
              .actualizarEstado(notifWow.idNotificacion, false)
              .subscribe({
                next: () => console.log('Notificación WOW expirada'),
                error: (err) => console.error(err),
              });
          }
 
          return;
        }
 
        console.log('NOTIF WOW:', notifWow);
        if (!wowActiva) {
          this.crearNotificacionMomentosWowBD();
          return;
        }
 
        this.notificacionMomentosWow = true;
        this.actualizarContadorNotificaciones();
      },
      error: (err) => {
        console.error(err);
        this.notificacionMomentosWow = false;
        this.actualizarContadorNotificaciones();
      },
    });
  }
 
  onMomentoWOWClick(): void {
    if (this.cargandoMomentosWow) {
      return;
    }
 
    this.cargandoMomentosWow = true;
    this.showTooltip = false;
 
    const body = {
      nombreClave: 'getMomentosWow',
      jsonParametros: JSON.stringify({
        idAsesor: this.cedulaAsesor,
      }),
    };
 
    forkJoin({
      visibles: this.momentosWowService.listarVisibles(this.cedulaAsesor),
      dataModal: this.momentosWowService.obtenerModal(body),
    }).subscribe({
      next: ({
        visibles,
        dataModal,
      }: {
        visibles: any[];
        dataModal: any[];
      }) => {
        const visiblesValidos = Array.isArray(visibles) ? visibles : [];
 
        console.log('cedulaAsesor actual:', this.cedulaAsesor);
        console.log('visibles WOW filtrados:', visiblesValidos);
 
        if (visiblesValidos.length === 0) {
          this.cargandoMomentosWow = false;
          this.cargarNotificacionMomentosWow();
          return;
        }
 
        const dataUnificada = (Array.isArray(dataModal) ? dataModal : [])
          .map((m) => {
            const match = visiblesValidos.find(
              (v) => v.idCliente === m.numeroDocumento,
            );
 
            if (!match) return null;
 
            return {
              ...m,
              ...match,
            };
          })
          .filter(Boolean);
 
        if (!dataUnificada.length) {
          this.cargandoMomentosWow = false;
          this.cargarNotificacionMomentosWow();
          return;
        }
 
        const cumpleanos = dataUnificada.filter(
          (d) => d.tipoMomento === 'CUMPLEAÑOS',
        );
 
        const quinquenios = dataUnificada.filter(
          (d) => d.tipoMomento === 'QUINQUENIO',
        );
 
        const nacimientos = dataUnificada.filter(
          (d) => d.tipoMomento === 'NACIMIENTO',
        );
 
        const dialogRef = this.dialog.open(DialogMomentosWowComponent, {
          panelClass: 'modal-momentos-wow',
          data: { cumpleanos, quinquenios, nacimientos },
        });
 
        dialogRef.afterOpened().subscribe(() => {
          this.cargandoMomentosWow = false;
        });
 
        dialogRef.afterClosed().subscribe(() => {
          this.cargarNotificacionMomentosWow();
        });
      },
      error: (err) => {
        console.error('Error cargando Momentos WOW', err);
        this.cargandoMomentosWow = false;
        this.cargarNotificacionMomentosWow();
      },
    });
  }
 
  resetMomentosWow() {
    this.notificacionMomentosWow = false;
    this.actualizarContadorNotificaciones();
    this.momentosWowData = [];
  }
 
  calcularFechaLimiteHabiles(fechaInicio: Date, diasHabiles: number): Date {
    const fecha = new Date(fechaInicio);
    let diasAgregados = 0;
 
    const cacheFestivos = new Map<number, string[]>();
 
    const obtenerFestivos = (anio: number): string[] => {
      if (!cacheFestivos.has(anio)) {
        const festivos = getHolidays(anio) as FestivoCO[];
 
        cacheFestivos.set(
          anio,
          festivos.map((f) => f.holiday),
        );
      }
      return cacheFestivos.get(anio)!;
    };
 
    while (diasAgregados < diasHabiles) {
      fecha.setDate(fecha.getDate() + 1);
 
      const diaSemana = fecha.getDay();
      const esFinSemana = diaSemana === 0 || diaSemana === 6;
 
      const fechaISO = fecha.toISOString().split('T')[0];
      const festivos = obtenerFestivos(fecha.getFullYear());
      const esFestivo = festivos.includes(fechaISO);
 
      if (!esFinSemana && !esFestivo) {
        diasAgregados++;
      }
    }
 
    return fecha;
  }
 
  public setTitle(title: string) {
    try {
      if (title != null || title != '') {
        this.sectionName = title;
      } else {
        this.sectionName = '';
      }
    } catch (err) {
      console.log('Error: setTitle()', err);
    }
  }
 
  goToNotificacionesCotizacion(): void {
    this.showTooltip = false;
    this.router.navigate(['/main/notificaciones-cotizacion']);
  }
 
  private cargarContadorNotificacionesCotizacion(): void {
    const usuario = String(this.idAsesor ?? '').trim();
    if (!usuario) {
      return;
    }
 
    this.contadorCotizacionSub?.unsubscribe();
    this.contadorCotizacionSub = this.notificacionesService
      .getContador(usuario)
      .subscribe({
        next: (resp) => {
          const total = Number(resp?.data ?? 0);
          this.notificacionesSeguimientoService.actualizarContador(
            Number.isFinite(total) ? total : 0,
          );
        },
        error: (err) =>
          console.error('Error al consultar alertas de cotización', err),
      });
  }
 
  goHome() {
    //force refresh to same page
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/main'], { skipLocationChange: true }).then(() => {
        this.router.navigate(['/main/portafolio']);
      });
    });
  }
 
  ngOnInit() {
    this.scrollSubscription = this.scrollService.hideScroll$.subscribe(
      (hide) => (this.hideScroll = hide),
    );
 
    this.notificacionesCotizacionSub.add(
      this.notificacionesSeguimientoService.getContadorNoLeidas().subscribe(
        (cantidad) => {
          this.notificacionesSeguimientoNoLeidas = cantidad;
          if (!this.showTooltip) {
            this.actualizarContadorNotificaciones();
          }
        },
      ),
    );
  }
 
  private formatearFechaYYYYMMDD(fecha: string): string {
    if (!fecha || fecha.length !== 8) return fecha;
 
    const anio = fecha.substring(0, 4);
    const mes = fecha.substring(4, 6);
    const dia = fecha.substring(6, 8);
 
    return `${dia}/${mes}/${anio}`;
  }
 
  private parseFechaYYYYMMDD(fecha: string): Date | null {
    if (!fecha || fecha.length !== 8) return null;
 
    const anio = Number(fecha.substring(0, 4));
    const mes = Number(fecha.substring(4, 6));
    const dia = Number(fecha.substring(6, 8));
 
    return new Date(anio, mes - 1, dia);
  }
 
  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
    this.notificacionesCotizacionSub.unsubscribe();
    this.contadorCotizacionSub?.unsubscribe();
  }
}